import { Route, Routes } from "react-router-dom";
import IdentityVerificationWebhook from "./identity-verification";
import { PathEnum } from "core/routes/path.enum";
import RipresaPraticaWebhook from "./ripresa-pratica";

const WebhookPage: React.FC = () => {
	return (
		<Routes>
			<Route
				path={PathEnum.identityVerificationWebhook}
				element={<IdentityVerificationWebhook />}
			/>
			<Route
				path={PathEnum.ripresaPraticanWebhook}
				element={<RipresaPraticaWebhook />}
			/>
		</Routes>
	);
};
export default WebhookPage;
